import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationDistrictActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/District/DistrictBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationDistrict"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationDistrict"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationDistrictActivity)
